import styled from "styled-components";

export const StyledCard = styled.div`
  background-color: #fff;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  max-width: 600px;
  margin: auto;
  margin-bottom: 60vh;
`;

export const StyledCardHeader = styled.div`
  text-align: center;
  font-size: 20px;
  margin-bottom: 10px;
  padding: 5px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
`;

export const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
`;

export const StyledImage = styled.img`
  height: 20vh;
`;

export const BodyContainer = styled.div`
  margin-bottom: 10px;
`;

export const FooterContainer = styled.div`
  padding-bottom: 7px;
`;
